export default __webpack_public_path__ + "static/media/swagger.4e26abc2.svg";